import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-service-aggrement',
  templateUrl: './service-aggrement.component.html',
  styleUrls: ['./service-aggrement.component.css']
})
export class ServiceAggrementComponent implements OnInit {

  constructor(private userService: UserService, private _location: Location, private router: Router ) {

  }

 ngOnInit(): void {
   this.userService.isRedirected$.next(true);
 }
  backClicked() {
    if (this.router.navigated) {
      this.router.navigate(['/'])
    } else {
      this.router.navigate(['/'])
    }

  }
}
